<template>
  <OnboardingFeatureView>
    <p>
      Ready to play?<br>Let’s update your profile first
    </p>
    <form
      class="OnboardingProfileView__form"
      data-theme="dark"
      :aria-busy="isSaving"
      @submit.prevent="$emit('submit')"
    >
      <fieldset
        class="OnboardingProfileView__fieldset"
        :disabled="isSaving"
      >
        <FormField label="Full name">
          <FormInput
            v-model="player.name"
            name="name"
            autocomplete="name"
            autocapitalize="words"
            :placeholder="namePlaceholder"
            isRequired
          />
        </FormField>

        <FormField label="Position">
          <PositionDropdown
            :modelValue="player.position ?? null"
            @update:modelValue="player.position = $event"
          />
        </FormField>

        <FormField
          label="Height"
        >
          <HeightInput
            :modelValue="player.height ?? null"
            @update:modelValue="player.height = $event"
          />
        </FormField>
      </fieldset>
      <FormButton
        type="submit"
        :disabled="isSaving"
      >
        Save
      </FormButton>
    </form>
  </OnboardingFeatureView>
</template>

<script lang="ts" setup>
import FormButton from "@/components/FormButton.vue";
import FormField from "@/components/FormField.vue";
import FormInput from "@/components/FormInput.vue";
import HeightInput from "@/components/HeightInput.vue";
import PositionDropdown from "@/components/PositionDropdown.vue";
import useAppTheme from "@/composables/useAppTheme";
import { topPlayerMap } from "@shared/lib/constants/players";
import { Theme } from "@shared/lib/constants/themes";
import { TablesInsert } from "@shared/lib/database/database.types";
import { computed } from "vue";
import OnboardingFeatureView from "./OnboardingFeatureView.vue";

const player = defineModel<TablesInsert<"players">>("player", {
  required: true,
});

defineEmits<{
  submit: [],
}>();

defineProps<{
  isSaving?: boolean,
}>();

const theme = computed(() => player.value.theme as keyof typeof Theme);

useAppTheme(theme);

const namePlaceholder = computed(() => {
  return topPlayerMap.get(theme.value || "LosAngelesLakers")?.name || "Lebron James";
});
</script>

<style lang="scss" scoped>
.OnboardingProfileView__form {
  display: grid;
  gap: 32px;
  align-content: center;
  width: 100%;
  max-width: 340px;

  color: var(--themeColorPrimaryForeground);

  text-align: center;
}

.OnboardingProfileView__body {
  font-size: 18px;
  font-stretch: var(--fontWidthExtended);
  text-wrap: balance;
  line-height: 1.5;
}

.OnboardingProfileView__fieldset {
  display: grid;
  gap: 24px;
}
</style>
